import React, { useState } from 'react'
import Modal from './Modal'

const MAX_REASON_LENGTH = 500

interface ConsumptionBypassModalProps {
  show: boolean
  title?: string
  close: () => void
  confirm: (reason: string) => void
}

const ConsumptionBypassModal: React.FC<ConsumptionBypassModalProps> = ({
  show,
  title,
  close,
  confirm,
}) => {
  const [reason, setReason] = useState('')

  const onHide = (): void => {
    setReason('')
    close()
  }

  const onConfirm = (): void => {
    confirm(reason)
    setReason('')
  }

  const isConfirmDisabled = !reason.trim()

  if (!show) {
    return null
  }

  return (
    <Modal
      title={title || 'Consumption Tracking Required'}
      hideModal={onHide}
      width="650px"
    >
      <p className="text-sm text-gray-700 mb-4 leading-relaxed">
        This order requires consumption tracking, but no items have been
        assigned consumption categories.
      </p>
      <p className="text-sm text-gray-700 mb-3 font-medium">
        Please provide a reason for creating an order without consumption
        categories:
      </p>
      <textarea
        className="w-full p-3 border border-gray-300 rounded text-sm min-h-[100px] resize-none focus:outline-none focus:border-blue-500 placeholder-gray-400"
        value={reason}
        onChange={(e) => setReason(e.target.value.slice(0, MAX_REASON_LENGTH))}
        placeholder="Enter reason here..."
        rows={5}
        maxLength={MAX_REASON_LENGTH}
      />
      <p className="text-xs text-gray-500 mt-1 text-right">
        {reason.length}/{MAX_REASON_LENGTH}
      </p>
      <div className="flex justify-end mt-5 gap-2">
        <button
          className="px-6 py-2 border border-gray-300 rounded bg-white text-gray-700 text-sm cursor-pointer hover:bg-gray-100"
          onClick={onHide}
        >
          Cancel
        </button>
        <button
          className={`px-6 py-2 border-none rounded bg-blue-500 text-white text-sm ${
            isConfirmDisabled
              ? 'opacity-60 cursor-not-allowed'
              : 'cursor-pointer hover:bg-blue-600'
          }`}
          onClick={onConfirm}
          disabled={isConfirmDisabled}
        >
          Create Order Anyway
        </button>
      </div>
    </Modal>
  )
}

export default ConsumptionBypassModal
